<section>
    <div class="sticky" #sticky>
        <header>
            <div class="team-container">
                <div class="team1">
                    <div class="photos" [ngClass]="{ doubles: isDoubles, singles: !isDoubles }">
                        <app-image
                            class="player1"
                            [country_flag_bottom]="team1.player2.id ? '52px' : '-4px'"
                            [player]="team1.player1"
                            [display_flag]="true"
                            (click)="openPlayerDetails('team1', 'player1')"
                        ></app-image>
                        @if (team1.player2.id) {
                            <app-image class="player2" [player]="team1.player2" [display_flag]="true" (click)="openPlayerDetails('team1', 'player2')"></app-image>
                        }
                    </div>
                    <div class="player-names">
                        <div class="player-add">
                            {{ handlePlayerName(team1.player1) }}
                            @if (!isDoubles) {
                                <mat-icon class="add-button" (click)="downloadAppDialog()">add_circle</mat-icon>
                            }
                        </div>
                        <div>{{ handlePlayerName(team1.player2) }}</div>
                    </div>
                </div>
                <div style="display: flex; align-items: center; color: #fafafa">
                    <h2>VS</h2>
                </div>
                <div class="team2">
                    <div class="photos" [ngClass]="{ doubles: isDoubles, singles: !isDoubles }">
                        <app-image
                            class="player1"
                            [country_flag_bottom]="team2.player2.id ? '52px' : '-4px'"
                            [player]="team2.player1"
                            [display_flag]="true"
                            (click)="openPlayerDetails('team2', 'player1')"
                        ></app-image>
                        @if (team2.player2.id) {
                            <app-image class="player2" [player]="team2.player2" [display_flag]="true" (click)="openPlayerDetails('team2', 'player2')"></app-image>
                        }
                    </div>
                    <div class="player-names">
                        <div class="player-add">
                            {{ handlePlayerName(team2.player1) }}
                            @if (!isDoubles) {
                                <mat-icon class="add-button" (click)="downloadAppDialog()">add_circle</mat-icon>
                            }
                        </div>
                        <div>{{ handlePlayerName(team2.player2) }}</div>
                    </div>
                </div>
            </div>
            <div class="match-sight-wrapper">
                @if (match_sights.length) {
                    <div class="match-sight">
                        <img class="match-sight-img" src="https://res.cloudinary.com/bleachr/image/upload/v1705918387/TennisONE/T1%20Logos/Chip_c2.png" alt="" />
                        <div class="fade"></div>
                        <app-carousel [config]="splideConfig">
                            @for (match_sight of match_sights; track match_sight) {
                                <app-slide class="scroll-style match-sight-slide">
                                    <article class="match-sight-body">
                                        {{ match_sight.body }}
                                    </article>
                                </app-slide>
                            }
                        </app-carousel>
                    </div>
                }
            </div>
        </header>
        @if (showMatchChat()) {
            <div class="chat-pill" (click)="openMatchChat()">
                <img src="https://res.cloudinary.com/bleachr/image/upload/v1655307085/TennisONE/T1%20Icons/chat_icon.png" />
                <app-app-string [key_name]="'tennischat.match.pill'"></app-app-string>
            </div>
        }
    </div>

    @if (!loading) {
        <app-tab-group class="tennis-match" [sticky_width]="sticky_width" (tabChanged)="handleTabChange($event)" style="box-sizing: border-box" [match_details]="true">
            @for (tab of match_tabs; track tab; let i = $index) {
                <app-tab>
                    <app-tab-label>
                        <div>
                            {{ appStringAPI.getAppString(tab.localization) }}
                        </div>
                    </app-tab-label>
                    @if (isActive && isActive.index === i) {
                        <app-tab-content>
                            <app-sponsor-banner [location]="screen_name" [sponsor_key]="'h2h-top'" [aspect_ratio]="'9:1'"></app-sponsor-banner>

                            @if (shouldShowStats() && tab.label === 'Stats') {
                                <div class="stats tracker">
                                    <app-stats-tracker
                                        [match_data]="match_data"
                                        (tabChange)="setTabChange($event)"
                                        [location]="screen_name"
                                        [sponsor_key]="sponsor_key"
                                        [aspect_ratio]="'9:1'"
                                    ></app-stats-tracker>
                                </div>
                            }
                            @if (tab.label === 'Odds') {
                                <app-odds-collapsable
                                    [match_status]="match_data.status"
                                    [match_id]="match_data.id"
                                    [hide_gambling_offers_match_scope]="!!(match_data && match_data.gaming_config && match_data.gaming_config.hide_gambling_offers)"
                                ></app-odds-collapsable>
                            }
                            @if (match_comment.length && tab.label === 'Recap') {
                                <div>
                                    <app-match-comment [match_comment]="match_comment" [match_data]="match_data"></app-match-comment>
                                </div>
                            }
                            @if (player_bios && tab.label === 'Bio') {
                                <div>
                                    <div class="section-header player-details">Player Details</div>
                                    <app-team-details [player_bio_data]="player_bios" [isDoubles]="isDoubles"></app-team-details>
                                </div>
                            }
                        </app-tab-content>
                    }
                </app-tab>
            }
        </app-tab-group>
    }
</section>
